// extracted by mini-css-extract-plugin
export default {"loadingIcon":"LoadingIcon_loadingIcon__aj4dD","rotating":"LoadingIcon_rotating__Ia+nl"};